import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
} from "@angular/core";
import {
    AbstractControl,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";

@Component({
    selector: "h-agec-search-bar",
    templateUrl: "./agec-search-bar.component.html",
    styleUrls: ["./agec-search-bar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgecSearchBarComponent implements OnChanges {
    @Output() public formSubmit = new EventEmitter<string>();

    @Input() public skuNotFound = false;

    public searchForm = new FormGroup({
        searchInput: new FormControl("", Validators.required),
    });

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    public get searchInput(): AbstractControl {
        return this.searchForm.get("searchInput") as AbstractControl;
    }

    /**
     * Because the validity of the input depends on conditions external to the value of the input itself,
     * its validity is managed in a non-dynmatical way.
     */
    public ngOnChanges(): void {
        if (this.skuNotFound) {
            this.searchInput.setErrors({
                invalid: true,
            });
            this.changeDetectorRef.detectChanges();
            return;
        }

        // eslint-disable-next-line unicorn/no-null
        this.searchInput.setErrors(null);
        this.changeDetectorRef.detectChanges();
    }

    public onSubmit(): void {
        this.formSubmit.emit(this.searchInput.value);
    }

    public setSearchBarValue(skuInput: string): void {
        this.searchForm.controls["searchInput"].patchValue(skuInput);
    }

    public handleKeyDown(keyboardEvent: KeyboardEvent): void {
        this.onSubmit();
        // When `Escape` is pressed, we simply clear the input only if input is not empty
        if (
            keyboardEvent.key === "Escape" &&
            this.searchForm.get("searchInput")?.value !== ""
        ) {
            keyboardEvent.stopPropagation();
            this.searchForm.get("searchInput")?.setValue("");
        }
    }
}
